// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Column = t.struct({
    key: t.String,
    value: t.String
}, 'Column');

export const getDefaultState = () =>
    new Column({
        key: '',
        value: ''
    });

export default Column;



// WEBPACK FOOTER //
// ./src/reports/basic-warranty-estimator/state/column.js